import React from 'react';

import * as S from './ReviewAndRatings.styles';

import getRatingsColor from '../../../../../shared/utils/getRatingsColor';

const ReviewAndRatings = ({
  hotelReview,
  ratingCount,
  reviewCount,
  ratingType = 0,
  breakup = [],
}) => {
  const isTA = ratingType === 3;
  return (
    <S.ReviewAndRatingOuterContainer>
      <S.HotelTotalReviewWrapper>
        {(hotelReview && (
          <S.AverageReviewWrapper bgColor={getRatingsColor(hotelReview)}>
            <S.AverageReviewText>{hotelReview} / <S.OutofRatingText>5</S.OutofRatingText></S.AverageReviewText>
          </S.AverageReviewWrapper>
        )) ||
          null}
        {(reviewCount && <S.TotalReviewCountText>{reviewCount} Reviews</S.TotalReviewCountText>) ||
          null}
      </S.HotelTotalReviewWrapper>
    </S.ReviewAndRatingOuterContainer>
  );
};

export default ReviewAndRatings;
